import React, { useState, useEffect, useRef } from "react";
import { oneKlicks } from "../../../../SDK/oneclick";
import { Link, useNavigate } from "react-router-dom";
import { encryptId } from "../../../../services/apiService";
import "./LatestArticles.css";

const LatestArticles = () => {
    const [articles, setArticles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'
    const [currentIndex, setCurrentIndex] = useState(0);
    const navigate = useNavigate();
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        fetchArticles();
    }, []);

    const handleArticleClick = (doctorId) => {
        navigate(`/doctor/${doctorId}/articles`);
    };

    const handleCategoryClick = (e, categoryName) => {
        e.stopPropagation();
        setSelectedCategory(categoryName);
        navigate(`/category/${categoryName}`);
    };

    const handleArticleTitleClick = (e, slug) => {
        e.stopPropagation();
        navigate(`/articles/${slug}`);
    };

    const handleShareArticle = (e, article) => {
        e.stopPropagation();
        if (navigator.share) {
            navigator.share({
                title: article.title,
                text: article.excerpt || 'Check out this health article',
                url: `${window.location.origin}/articles/${article.slug}/${encryptId(article.id)}`
            });
        } else {
            // Fallback: copy to clipboard
            navigator.clipboard.writeText(`${window.location.origin}/articles/${article.slug}/${encryptId(article.id)}`);
            alert('Link copied to clipboard!');
        }
    };

    const handleBookmarkArticle = (e, articleId) => {
        e.stopPropagation();
        // Add bookmark logic here
        console.log('Bookmark article:', articleId);
    };

    const handleLikeArticle = (e, articleId) => {
        e.stopPropagation();
        // Add like logic here
        console.log('Like article:', articleId);
    };

    const handleViewModeToggle = () => {
        setViewMode(viewMode === 'grid' ? 'list' : 'grid');
    };

    const scrollLeft = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    const scrollRight = () => {
        if (currentIndex < articles.length - 3) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const fetchArticles = async () => {
        try {
            const tableSchema = "articles";
            const tableName = "articles";
            const conditions = {
                status: "published",
            };
            const orderBy = "RAND()";
            const search = {};
            const pagination = { page: 1, limit: 12 }; // Increased to 12 articles for better scrolling
            const margedata = [
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "doctor_id",
                    target_label: "doctors"
                },
                {
                    target_table: "users",
                    target_column: "id",
                    target_value: "hospital_id",
                    target_label: "hospitals"
                },
                {
                    target_table: "specialities",
                    target_column: "id",
                    target_value: "categories",
                    target_label: "categories"
                }
            ];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            console.log("articles", response.data);
            setArticles(response.data);
        } catch (error) {
            setArticles([]);
            console.log("articles error", error);
        } finally {
            console.log("articles loading", loading);
            setLoading(false);
        }
    }

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner">
                    <div className="spinner"></div>
                    <p>Loading Latest Articles...</p>
                </div>
            </div>
        );
    }

    // Get current 3 articles to display (sliding window)
    const currentArticles = articles.slice(currentIndex, currentIndex + 3);
    const canScrollLeft = currentIndex > 0;
    const canScrollRight = currentIndex < articles.length - 3;

    return (
        <section className="elementor-section elementor-top-section elementor-element elementor-element-59d3be7 elementor-section-stretched elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-id="59d3be7" data-element_type="section" data-settings='{"stretch_section":"section-stretched"}' >
            <div className="elementor-container elementor-column-gap-no">
                <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e779799" data-id="e779799" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-7625199 elementor-widget elementor-widget-dc_element_latest_articles" data-id="7625199" data-element_type="widget" data-widget_type="dc_element_latest_articles.default">
                            <div className="elementor-widget-container">
                                <div className="dc-sc-latest-articals dc-haslayout">
                                    <div className="container">
                                        <div className="row justify-content-center align-self-center">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 push-lg-2">
                                                <div className="dc-sectionhead dc-text-center">
                                                    <div className="dc-sectiontitle">
                                                        <h2>
                                                            <span>Read Professional Articles</span>
                                                            Latest <em>Articles</em>
                                                        </h2>
                                                    </div>
                                                    <div className="dc-description">
                                                        <p>Stay informed with the latest health tips, trends, and medical insights. Explore our curated articles to keep your health knowledge up to date!</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="dc-articlesholder">
                                            {currentArticles && currentArticles.length > 0 ? currentArticles.map((article, index) => (
                                                <div key={article.id} className="col-12 col-sm-12 col-md-6 col-lg-4 float-left mb-4">
                                                    <div className="dc-article">
                                                        <figure className="dc-articleimg">
                                                            <img 
                                                                decoding="async" 
                                                                width="" 
                                                                height="" 
                                                                style={{width: '100%', height: '200px'}}
                                                                src={`${process.env.REACT_APP_API_BASE_URL}${article.featured_image}` || "https://doctreat.amentotech.com/wp-content/uploads/2019/09/012-545x389.jpg"} 
                                                                alt={article.title}
                                                            />
                                                            <figcaption>
                                                                <div className="dc-articlesdocinfo">
                                                                    <img 
                                                                        decoding="async" 
                                                                        style={{width: '30px', height: '30px'}}
                                                                        src={`${process.env.REACT_APP_API_BASE_URL}${article.doctors?.[0]?.profile_photo_url || article.hospitals?.[0]?.profile_photo_url}` || "https://doctreat.amentotech.com/wp-content/uploads/2019/11/11-30x30.jpg"} 
                                                                        alt={article.doctors?.[0]?.display_name || article.hospitals?.[0]?.display_name || "Author"}
                                                                    />
                                                                    <span>{article.doctors?.[0]?.display_name || article.hospitals?.[0]?.display_name || "Anonymous"}</span>
                                                                </div>
                                                            </figcaption>
                                                        </figure>
                                                        <div className="dc-articlecontent">
                                                            <div className="dc-title">
                                                                <Link to={`/category/${article.categories?.[0]?.name}`} rel="tag" onClick={(e) => handleCategoryClick(e, article.categories?.[0]?.name)}>
                                                                    {article.categories?.[0]?.name || "General"}
                                                                </Link>
                                                                <h3>
                                                                    <Link to={`/articles/${article.slug}/${encryptId(article.id)}`} onClick={(e) => handleArticleTitleClick(e, article.slug)}>
                                                                        {article.title}
                                                                    </Link>
                                                                </h3>
                                                                <span className="dc-datetime">
                                                                    <i className="lnr lnr-clock"></i> 
                                                                    {new Date(article.created_at).toLocaleDateString('en-US', { 
                                                                        year: 'numeric', 
                                                                        month: 'long', 
                                                                        day: 'numeric' 
                                                                    })}
                                                                </span>
                                                            </div>
                                                            <ul className="dc-moreoptions">
                                                                <li className="dcget-likes" data-key={article.id}>
                                                                    <span onClick={(e) => handleLikeArticle(e, article.id)} style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                                                                        <i className="ti-heart"></i>
                                                                        {article.likes || 0} Likes
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                                                                        <i className="ti-eye"></i>
                                                                        {article.views || 0} Views
                                                                    </span>
                                                                </li>
                                                                <li>
                                                                    <span style={{display: 'flex', gap: '4px', alignItems: 'center'}}>
                                                                        <i className="ti-comment"></i>
                                                                        {article.comments || 0} Comments
                                                                    </span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            )) : (
                                                <div className="col-12">
                                                    <div className="dc-article">
                                                        <div className="dc-articlecontent">
                                                            <div className="dc-title">
                                                                <h3>No Articles Found</h3>
                                                                <p>We couldn't find any articles at the moment. Please check back later.</p>
                                                                <button onClick={fetchArticles}>
                                                                    <i className="fas fa-sync-alt"></i>
                                                                    <span>Refresh</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-12"
                                            style={{display: 'flex', justifyContent: 'center', marginTop: '20px'}}
                                        >
                                            <button onClick={() => navigate('/articles')} className="btn btn-primary">
                                                Load More
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LatestArticles;
